<div class="counts" *ngIf="appointmentCounts">
  <mat-expansion-panel class="count-panel" [hideToggle]="true">
    <mat-expansion-panel-header class="header">
      <mat-panel-title class="panel-title"
        >Appointments
        <span>{{ appointmentCounts.total }}</span></mat-panel-title
      >
    </mat-expansion-panel-header>
    <div class="panel-body">
      <div
        class="panel-item"
        [routerLink]="[
          'counts/list',
          'appointmentCounts',
          'scheduledAppointmentBacklog'
        ]"
      >
        <p class="count">Scheduled Appt Backlog</p>
        <span>{{ appointmentCounts.scheduledAppointmentBacklog }}</span>
      </div>
    </div>
  </mat-expansion-panel>
</div>
